import '../../styles/web-components/search-form.scss';
import { SEARCH_CLOSE } from "../constants/events.constants";
import { emitShopifyEvent } from "../services/analytics.service";
class SearchForm extends HTMLElement {
    constructor() {
        super();
    }
    form;
    searchInput;
    resetButton;
    async connectedCallback() {
        this.form = this.querySelector('form');
        this.searchInput = this.querySelector('input');
        this.resetButton = this.querySelector('.search-form__reset');
        this.form.addEventListener('submit', () => this.handleSubmit());
        this.resetButton.addEventListener("click", () => this.handleReset());
    }
    handleSubmit() {
        const term = this.searchInput.value;
        if (term) {
            emitShopifyEvent("updated_search_submitted", { "search_term": term });
        }
    }
    handleReset() {
        this.searchInput.value = '';
        this.setFocus();
    }
    handleClose() {
        this.dispatchEvent(new CustomEvent(SEARCH_CLOSE, { bubbles: true }));
    }
    setFocus(options) {
        this.searchInput.focus(options);
    }
}
if (!window.customElements.get("search-form")) {
    customElements.define("search-form", SearchForm);
}
